module.exports = __webpack_public_path__ + "static/media/OnitsukaTiger_black.f9883d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/pdf/templates/vlp/images/OnitsukaTiger_black.png
// module id = 284
// module chunks = 10